<template>
      <div class="contents">
            <template v-if="isArray">
                  <tr :class="odd ? 'odd' : null">
                        <td
                              v-for="(column, index) in columns" 
                              :key="'val-'+ index" 
                              v-html="$options.filters.formatData({item: item[column], isDinamic: isDinamic(index), dinamicColumn})" 
                              class="p-2 last:pr-0"
                        >
                        </td>
                  </tr>
            </template>
            <template v-else>
                  <tr :class="odd ? 'odd' : null" v-show="collapsed">
                        <td
                              v-for="(column, index) in columns"
                              :key="'val-'+ index"
                              v-html="$options.filters.formatData({item: item[column]})"
                              class="p-2 last:pr-0 w-56 break-all"
                              :class="showMoreVisible ? 'showMoreVisible' : null"
                        ></td>
                  </tr>
            </template>
      </div>
</template>

<script>
import { mapActions } from 'vuex'
import Vue from "vue";

export default {
      name: 'tableRow',
      props: {
            item: {
                  type: Object,
                  required: true,
            },
            isArray: {
                  type: Boolean,
                  required: true,
            },
            collapsed: {
                  default: false,
                  type: Boolean,
                  required: false,
            },
            showMoreVisible: {
                  default: false,
                  type: Boolean,
            },
            columns: {
                  type: Array,
                  required: true,
            },
            dinamicColumn: {
                  type: Object,
                  required: true,
            },
            odd: {
                  type: Boolean,
                  required: true,
            },
      },
      data(){
            return {
            }
      },
      methods: {
            ...mapActions({
                  getHistoricalData: 'getHistoricalData',
            }),
            isDinamic(index) {
                  return index === this.dinamicColumn.index
            },
            getLinkedItems(){
                  return document.getElementsByClassName('dinamic-link');
            }
      },
      filters: {
            formatData: function (content) {
                  const dinamicColumn = content.dinamicColumn;
                  const isDinamic = content.isDinamic;
                  const data = content.item
                  let output = '';
                  if(data === null) {
                        output = '<span>-</span>'
                  } else if(Array.isArray(data)) {
                        // if it's array
                        if(data.length){
                              // if element of array is object, for example:
                              // [{$type: "DeviceUserIdentity", Email: "16381151096162239368@android-for-work.gserviceaccount.com"}]
                              if(typeof data[0] === 'object'){
                                    output += '<ul class="divide-y">'
                                    for (const obj of data) {
                                          output += '<li><ul>'
                                          for (const [key, value] of Object.entries(obj)) {
                                                output += `<li>${key}: <strong>${value}</strong></li>`
                                          }
                                          output += '</li></ul>'
                                    }
                                    output += '</ul>'
                              } else {
                              // if item is string, for example
                              // ["AndroidRcRemoteView", "AndroidWorkManagedProfile"]
                                    output = '<ul>'
                                    for (const obj of data) {
                                          output += `<li>${obj}</li>`
                                    }
                                    output += '</ul>'
                              }

                        } else {
                              output = '<span>-</span>'
                        }
                  } else if(typeof data === 'object') {
                        // if it's object, for example:
                        // {$type: "ComplianceItem", ComplianceType: "IsEnrolled", ComplianceValue: true}
                        if(Object.entries(data).length){
                              output = '<ul>'
                              for (const [key, value] of Object.entries(data)) {
                                    output += `<li>${key}: <strong>${value}</strong></li>`
                              }
                              output += '</ul>'
                        } else {
                              output = '<span>-</span>'
                        }

                  } else {
                        if (data === 'None' || data === undefined) {
                              output ='<span>-</span>'
                        } else if (data === true) {
                              output ='<span><svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><polyline points="20 6 9 17 4 12"></polyline></svg></span>'
                        } else if(data === false) {
                              output ='<span><svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></span>'
                        } else {
                              if (data.toString().length) {

                                    if(!isDinamic) {
                                          output = `<span>${Vue.unifyDateFormat(data)}</span>`
                                    }
                                    else {
                                          output = `<span class="flex space-x-2">${data} <span class="text-bold cursor-pointer ml-2 items-center dinamic-link" data-dinamic-id="${data}" data-dinamic-column="${dinamicColumn.name}"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg></span></span>`
                                    }
                              } else {
                                    output = '<span>-</span>'
                              }
                        }
                  }
                  return output
            }
      },
      
}
</script>

<style lang="sass">
.contents
  tr.odd
    @apply bg-gray-100
tr
  td
    word-wrap: break-word

</style>